import { useEffect } from 'react';

export function useKey(keyCode, callback) {
  useEffect(
    function () {
      function cb(e) {
        if (e.code.toLowerCase() === keyCode.toLowerCase()) {
          callback();
        }
      }

      document.addEventListener('keydown', cb);

      return function () {
        document.removeEventListener('keydown', cb);
      };
    },
    [keyCode, callback]
  );
}
